import type { ReorderGroups } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/**
 * Reorder the preset groups for the specified device.
 *
 * @param deviceId - The ID of the device for which the preset groups are to be reordered.
 * @param groupIds - New group order.
 */
export const reorderGroups: ReorderGroups = async (deviceId, groupIds, token): Promise<void> => {
  try {
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      throw new Error('CZ-131');
    }

    const mutation = Object.fromEntries(
      groupIds.map((groupId, index) => [groupId, { rank: index }])
    );

    await proxy.mutate(
      {
        control: {
          studio: {
            device: {
              [deviceId]: {
                control: {
                  presets: {
                    groups: mutation
                  }
                }
              }
            }
          }
        }
      },
      {}
    );

    await proxy.save(token);
  } catch (cause) {
    throw new StudioError('Unable to reorder preset groups.', { cause });
  }
};
